<template>
    <div>
        <b-modal id="modal-smart-drop-plus" centered hide-footer no-close-on-backdrop :body-class="'px-4 pb-4 pt-3'" no-close-on-esc
        >
            <template #modal-header="{ close }">
                <h5 class="modal-title">
                    {{ $t('smartDropPlus.title') }}
                </h5>
                <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                    Close Modal
                </b-button>
            </template>
            <div class="d-block text-center">
                <b-row>
                    <b-col lg="6" md="8" sm="12">
                        <div class="text-left mb-3">
                            <label class="state">{{ $t('smartDropPlus.botTypeLabel') }}</label>
                            <b-form-select type="text" class="input f-12" v-model="documentData.type" :options="botTypeOptions"></b-form-select>
                             <p v-if="errors && errors.type" class="field-error">
                                {{ errors.type[0] }}
                            </p>
                        </div>
                         <div class="text-left mb-3" v-if="documentData.type === 'Dot Inspection'">
                            <label class="state">{{ $t('smartDropPlus.expiryDateFromDoc') }}</label>
                            <b-form-select type="text" v-model="documentData.optional_expiry" class="input f-12" :options="optionalExpiryOptions"></b-form-select>
                            <p v-if="errors && errors.optional_expiry" class="field-error">
                                {{ errors.optional_expiry[0] }}
                            </p>
                        </div>
                        <div class="text-left mb-3" v-if="documentData.type === 'Permit'">
                            <label for="modal-expiry-date" class="state">{{ $t('smartDropPlus.expiryDateLabel') }}</label>
                            <date-picker v-model="documentData.expiry_date" :formatter="momentFormat"
                                :range-separator="' - '" @clear="documentData.expiry_date = ''" :placeholder="$t('smartDropPlus.selectDate')"
                                class="date-picker-custom" :teleport="'body'"></date-picker>
                        </div>
                        <div class="text-left mb-3" v-if="documentData.type === 'Registration'">
                            <label class="state">{{ $t('smartDropPlus.expiryDateRequiredLabel') }}</label>
                            <b-form-select type="text" v-model="documentData.expiry_date_required" class="input f-12"
                                :options="expiryRequiredOptions"></b-form-select>
                            <p v-if="errors && errors.expiry_date_required" class="field-error">
                                {{ errors.expiry_date_required[0] }}
                            </p>
                        </div>
                        <div class="text-left mb-3">
                            <label class="state">{{ $t('smartDropPlus.modelLabel') }}</label>
                            <b-form-select type="text" v-model="documentData.model" class="input f-12" :options="modelSelectOptions"></b-form-select>
                            <p v-if="errors && errors.model" class="field-error">
                                {{ errors.model[0] }}
                            </p>
                        </div>
                       
                        <div class="text-left mb-3">
                            <label class="state">{{ $t('smartDropPlus.docTypeLabel') }}</label>
                            <b-form-select type="text" v-model="documentData.doc_type" class="input f-12"
                                :options="getDotOptions" @change="setDocDescription($event)"></b-form-select>
                            <p v-if="errors && errors.doc_type" class="field-error">
                                {{ errors.doc_type[0] }}
                            </p>
                        </div>
                        <div class="text-left mb-3">
                            <label class="state">{{ $t('smartDropPlus.descriptionLabel') }}</label>
                            <b-form-textarea id="textarea" class="f-12" v-model="documentData.description"
                                :placeholder="$t('smartDropPlus.descriptionPlaceholder')" rows="5"></b-form-textarea>
                            <p v-if="errors && errors.description" class="field-error pb-4">
                                {{ errors.description[0] }}
                            </p>
                        </div>
                    </b-col>
                    <b-col lg="6" md="8" sm="12">
                        <div class="upload-btn-wrapper h-240px">
                            <b-img :src="require('@/assets/drop.svg')"></b-img>
                            <button v-if="!smartDropPlusUploadFileName" class="foo">
                                {{ $t('smartDropPlus.dropZip') }}
                            </button>
                            <button v-else class="foo">{{ smartDropPlusUploadFileName }}</button>
                            <p v-if="smartDropPlusUploadFileName"
                                class="mb-0 field-error cursor-pointer font-12 position-relative error-button"
                                @click="removeFile()">
                                {{ $t('smartDropPlus.delete') }}
                            </p>
                            <input ref="smartDropPlus" type="file" name="myfile" v-on:change="handleFileUpload"
                                accept=".zip,.pdf,application/zip,application/x-zip,application/x-zip-compressed,application/octet-stream,application/pdf" />
                            <p v-if="errors && errors.document" class="field-error">
                                {{ errors.document[0] }}
                            </p>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <div class="text-right modal-footer border-0 p-0">
                <b-button class="mt-3 mr-3 btn cancel" block @click="resetPopup()">{{ $t('smartDropPlus.cancel') }}</b-button>
                <b-button class="mt-3 btn save mx-0" variant="primary" @click="sendDocumentData">{{ $t('smartDropPlus.save') }}</b-button>
            </div>
        </b-modal>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import * as moment from "moment-timezone";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { checkDescriptionLength } from '@/services/helper';
export default {
    name: "SmartDropPlus",
    components:{DatePicker},
    data() {
        return {
            smartDropPlusUploadFileName: "",
            checkDescriptionLength,
            momentFormat: {
                stringify: (date) => {
                    return date ? moment(date).format('ll') : ''
                },
                parse: (value) => {
          if (!value) return null
          const formats = [
            'll', 'LL',
            'MMM D, YYYY', 'MMMM D, YYYY',
            'M/D/YYYY', 'MM/DD/YYYY',
            'M-D-YYYY', 'MM-DD-YYYY',
            'YYYY-MM-DD', 'YYYY/MM/DD',
            'D MMM YYYY', 'D MMMM YYYY',
            'D/M/YYYY', 'DD/MM/YYYY',
          ]
          const m = moment(value, formats, true)
          if (m.isValid()) return m.toDate()
          const lenient = moment(value)
          return lenient.isValid() ? lenient.toDate() : null
        }
            },
            errors: {},
            documentData: {
                type: "",
                expiry_date_required: "",
                expiry_date: "",
                description: "",
                document: null,
                model: "",
                doc_type: "",
                optional_expiry: "1 yr"
            }
        }
    },
    computed: {
        ...mapGetters(["userCompany", 'company', "docTypeItems"]),
        botTypeOptions() {
            return [
                { value: '', text: '' },
                { value: 'Registration', text: this.$t('smartDropPlus.botRegistration') },
                { value: 'Dot Inspection', text: this.$t('smartDropPlus.botDotInspection') },
                { value: 'Permit', text: this.$t('smartDropPlus.botPermit') },
                { value: 'CDL', text: this.$t('smartDropPlus.botCdl') },
                { value: 'Medical Card', text: this.$t('smartDropPlus.botMedicalCard') },
            ];
        },
        optionalExpiryOptions() {
            return [
                { value: '3 mo', text: '3 MO' },
                { value: '6 mo', text: '6 MO' },
                { value: '1 yr', text: '1 YR' },
                { value: '2 yr', text: '2 YR' },
                { value: '3 yr', text: '3 YR' },
                { value: '4 yr', text: '4 YR' },
                { value: '5 yr', text: '5 YR' },
            ];
        },
        expiryRequiredOptions() {
            return [
                { value: null, text: '' },
                { value: 'True', text: this.$t('smartDropPlus.yes') },
                { value: 'False', text: this.$t('smartDropPlus.no') },
            ];
        },
        modelSelectOptions() {
            return [
                { value: '', text: '' },
                { value: 'Driver', text: this.$t('smartDropPlus.modelDriver') },
                { value: 'Vehicle', text: this.$t('smartDropPlus.modelVehicle') },
                { value: 'Trailer', text: this.$t('smartDropPlus.modelTrailer') },
            ];
        },
        getDotOptions() {
            if (this.documentData.model)
                return [...[{
                    value: "",
                    text: "",
                }], ...this.docTypeItems?.filter((item) => item.model === this.documentData.model || item.model === 'All').map((item) => {
                    return {
                        value: item.id,
                        text: item.type,
                    }
                })]
            else return []
        },
    },
    methods: {
        ...mapActions(["smartDropPlus", "setLoader", "setNotification"]),
        setDocDescription(event) {
            if (event) {
                this.documentData.description = this.getDotOptions.filter((option) => option.value === event)[0].text
            }
            else this.documentData.description = ""
        },
        handleFileUpload() {
            const file = this.$refs.smartDropPlus.files[0];
            if (!file) return;
            const ext = file.name.split('.').pop().toLowerCase();
            if (!['zip', 'pdf'].includes(ext)) {
                this.errors = { document: [this.$t('smartDropPlus.onlyZipPdf')] };
                this.$refs.smartDropPlus.value = '';
                return;
            }
            this.errors = {};
            this.documentData.document = file;
            this.smartDropPlusUploadFileName = file.name;
        },
        removeFile() {
            this.smartDropPlusUploadFileName = null;
            this.$refs.smartDropPlus.value = "";
        },
        resetPopup() {
            this.$bvModal.hide('modal-smart-drop-plus')
            this.documentData = {
                type: "",
                expiry_date_required: "",
                expiry_date: "",
                description: "",
                document: null,
                model: "",
                doc_type: "",
                optional_expiry: "1 yr"
            }
            this.removeFile()
            this.errors = {}
        },
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (!value) {
                    nullKeys.push(key);
                }
            }
            return nullKeys;
        },
        async sendDocumentData() {
            try {
                if (this.documentData.description && this.checkDescriptionLength(this.documentData.description)) {
          throw {
            description: [this.$t('smartDropPlus.descriptionMaxLength')],
          };
        }
                const nullKeys = this.checkNullValues({
                    ...this.documentData.type === 'Registration' ? { expiry_date_required: this.documentData.expiry_date_required } : {},
                    type:this.documentData.type,
                    document: this.documentData.document,
                    description: this.documentData.description,
                    ...this.company[0].doc_type ? { model: this.documentData.model, doc_type: this.documentData.doc_type } : {}
                });
                if (nullKeys.length === 0) {
                    this.setLoader(true);
                    let formData = new FormData();
                    formData.append("type", this.documentData.type);
                    formData.append("company_id", this.userCompany);
                    formData.append("description", this.documentData.description);
                    if (this.documentData.doc_type) formData.append("doc_type", this.documentData.doc_type);
                    if (this.documentData.type === 'Registration') {
                        formData.append("expiry_date_required", this.documentData.expiry_date_required);
                    }
                    if(this.documentData.type === 'Dot Inspection') {
                        formData.append("optional_expiry", this.documentData.optional_expiry);
                    }
                    if (this.documentData.expiry_date) formData.append("expiry_date", moment(this.documentData.expiry_date).format("YYYY-MM-DD"));
                    if (this.documentData.document) formData.append("zip_file", this.documentData.document);
                    await this.smartDropPlus(formData)
                    await this.setNotification({
                        msg: this.$t('smartDropPlus.docAdded'),
                        type: "success",
                        color: "green",
                    });
                    this.resetPopup()
                    this.$emit("success")
                    this.setLoader(false);
                }
                else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = [this.$t('smartDropPlus.fieldRequired')];
                    });
                    throw error;
                }
            }
            catch (error) {
                this.setLoader(false);
                if (typeof error === "object") {
                    this.errors = error;
                }
            }
        }
    },
}
</script>